export default [
    {
        path: '/authentication',
        name: 'authentication-options',
        component: () => import('@/modules/authentication/views/AuthenticationOptions.vue')
    },
    {
        path: '/authentication/failed',
        name: 'authentication-failed',
        component: () => import('@/modules/authentication/views/AuthenticationFailed.vue')
    },
    {
        path: '/authentication/self',
        name: 'authentication-self',
        component: () => import('@/modules/authentication/views/AuthenticationSelf.vue')
    },
    {
        path: '/authentication/fpt-id',
        name: 'authentication-fpt-id',
        component: () => import('@/modules/authentication/views/AuthenticationFptId.vue')
    },
    {
        path: '/authentication/fpt-id/success',
        name: 'authentication-fpt-id-success',
        component: () => import('@/modules/authentication/views/AuthenticationFptIdSuccess.vue')
    }
]
